import React, { } from 'react'
import log from 'lib/log'
import GroupTools from '../GroupTools'
import { loadAvailableGroups } from 'actions/groups'
import universal from 'react-universal-component'
import AsyncPage from 'pages/AsyncPage'
const component = universal(props => import('./GroupsDiscoverPage'))

class AsyncDiscoverGroupsPage extends AsyncPage {
  nonav = true
  constructor() {
    super({
      pageComponent: component
    })
  }
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    const { session: { value: profile } } = getState()
    if (profile) {
      try {
        await loadAvailableGroups({})(dispatch, getState, opts)
      } catch (e) {
        log.error(e)
      }
    } else {
      // not logged-in, what should anonymous users see? nothing?
    }
  }
  getExtraSecondaryNavigation({ place }) {
    return <GroupTools {...place} searchAction={loadAvailableGroups} />
  }
}

export default new AsyncDiscoverGroupsPage()
